// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_4k-0";
export var eligibilityCardNotEligible = "_4k-1";